export enum PaymentStatus {
  PendingVerification = 'PendingVerification', // Avvaktar Verifiering
  Authorized = 'Authorized', // Reserverad
  Captured = 'Captured', // Betald
}
